import React from 'react';
import { IconProps } from './types';

const OutputMetric: React.FC<IconProps> = props => {
  const { className, size = '32', fillColor = '#626BFE' } = props;
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox={`0 0 ${size} ${size}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width={size} height={size} rx="4" fill={fillColor} />
      <path
        d="M13.84 10.0899V16.2799C13.84 16.8322 14.2878 17.2799 14.84 17.2799H17.16C17.7123 17.2799 18.16 16.8322 18.16 16.2799V10.0899H20.46L16 5.18994L11.54 10.0899H13.84Z"
        fill="white"
      />
      <path
        d="M22.4103 11.1499H23.2203C24.3203 11.1499 25.2203 12.0499 25.2203 13.1499V25.3999H6.78027V13.1499C6.78027 12.0499 7.68027 11.1499 8.78027 11.1499H9.59027"
        stroke="white"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M25.2103 20.54H6.78027V25.4H25.2103V20.54Z" fill="white" />
    </svg>
  );
};

export default OutputMetric;
